module.exports={render:function (){with(this) {
  return _h('div', {
    staticClass: "lazy-wrap"
  }, [_h('transition', {
    attrs: {
      "name": "show"
    }
  }, [(itemState !== 'hide') ? _h('div', {
    staticClass: "lazy-content"
  }, [_h('div', {
    staticClass: "img-wrap"
  }, [_h('img', {
    class: {
      blur: itemState === 'small'
    },
    attrs: {
      "src": imgSrc
    }
  })]), " ", (itemData.desc) ? _h('div', {
    staticClass: "desc"
  }, [_h('p', [_s(itemData.desc)])]) : _e()]) : _e()]), " ", (itemState === 'hide') ? _h('div', {
    staticClass: "lazy-replace"
  }, [_m(0)]) : _e()])
}},staticRenderFns: [function (){with(this) {
  return _h('span', ["lazy-item"])
}}]}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LazyItem.vue
 ** module id = 12
 ** module chunks = 1
 **/